export default "__VITE_ASSET__Dfk9N17w__"